import { API } from '../../config/api';
import { DELETE, GET } from '../../utils/apicalls';
import { Button, Card, notification, Space, Table } from 'antd';
import { useEffect, useState } from 'react'

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);

function ViewActiveOffer() {
    const [isLoading, setIsLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [meta, setMeta] = useState<any>({});
    const [data, setData] = useState<any>([]);


    useEffect(() => {
        fetchofferproduct()
    }, []);
    const fetchofferproduct = async () => {
        try {
            setIsLoading(true);
            const url = API.ACTIVE_OFFER_PRODUCT;
            const response: any = await GET(url, {});

            // Convert UTC times to local timezone for display
            const formattedData = response?.data?.map((item: any) => ({
                ...item,
                Offer_start_time: item.Offer_start_time ?
                    dayjs.utc(item.Offer_start_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
                Offer_End_time: item.Offer_End_time ?
                    dayjs.utc(item.Offer_End_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : ''
            }));

            setData(formattedData);
            setMeta(response?.meta);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_OFFER_PRODUCT}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                fetchofferproduct()
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "Offer_start_time", dataIndex: "Offer_start_time" },


        { title: "Offer_End_time", dataIndex: "Offer_End_time" },
        { title: "Offer_price", dataIndex: "Offer_price" },
        {
            title: "Product_id", dataIndex: "Product", render: (_: any, record: any) => (
                <span>{record?.Productid?.productTitle}</span>
            ),
        },


        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>
                        Delete
                    </Button>
                    {/* <Button
                        type="link"
                        onClick={() =>
                            navigate(`/admin/offerpage/updateoffer/${record.id}`)
                        }
                    >
                        Edit
                    </Button> */}
                </Space>
            ),
        },
    ];

    return (
        <div>
            <h1>
                Active Offers List
            </h1>
            <Card>
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={isLoading}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: meta?.total,
                        showSizeChanger: true, // Allows users to change page size
                        onChange: (newPage, newPageSize) => {
                            setPage(newPage);
                            setPageSize(newPageSize);

                        },
                    }}
                    rowKey={(record: any) => record.id}
                    scroll={{ x: "max-content" }}
                />
            </Card>
        </div>
    )
}

export default ViewActiveOffer
